"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityTypePluralIconLabel = exports.EntityTypePluralIconLabelDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_lang_1 = require("../../hooks/use-lang");
var icon_label_1 = require("../elements/icon-label");
var entity_type_icon_1 = require("./entity-type-icon");
exports.EntityTypePluralIconLabelDefaultProps = {
  size: 'small'
};
// -------- Styles -------->
// -------- Components -------->
var My = {
  Container: icon_label_1.IconLabel
};
var EntityTypePluralIconLabel = function (props) {
  var entityTypeName = props.entityTypeName,
    children = props.children,
    rest = __rest(props, ["entityTypeName", "children"]);
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var t = (0, use_lang_1.useLang)();
  return react_1.default.createElement(My.Container, __assign({}, rest, {
    icon: react_1.default.createElement(entity_type_icon_1.EntityTypeIcon, {
      entityTypeName: entityTypeName
    })
  }), children || t(definition.pluralLabel));
};
exports.EntityTypePluralIconLabel = EntityTypePluralIconLabel;
exports.EntityTypePluralIconLabel.defaultProps = exports.EntityTypePluralIconLabelDefaultProps;